import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Line,
  Path,
  Rect,
  Svg,
  Circle as _Circle
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Path, { d: "M16 18a4 4 0 0 0-8 0", stroke: `${color}` }),
        /* @__PURE__ */ jsx(_Circle, { cx: "12", cy: "11", r: "3", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Rect, { width: "18", height: "18", x: "3", y: "4", rx: "2", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Line, { x1: "8", x2: "8", y1: "2", y2: "4", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Line, { x1: "16", x2: "16", y1: "2", y2: "4", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "Contact2";
const Contact2 = memo(themed(Icon));
export {
  Contact2
};
//# sourceMappingURL=contact-2.js.map
